import React, { useEffect, useMemo, useState } from "react";
import styles from "./tactics-selector-modal.module.css";
import { getUIText } from "../../../translation";
import { SAVIOR_ATTRIBUTE, SAVIOR_CLASS } from "../../../constants";

export default function TacticsSelectorModal({ lang, editingTactics, setEditingTactics, setTactics }) {
    const [editing, setEditing] = useState(editingTactics ? structuredClone(editingTactics) : null);

    useEffect(() => {
        if (editingTactics) {
            setEditing(structuredClone(editingTactics));
        }
    }, [editingTactics]);

    const submitEquip = (equip) => {
        setTactics(equip);
        setEditingTactics(null);
    };

    const changeLevel = (major, sub, textValue) => {
        let value = Number(textValue);
        if (Number.isNaN(value)) {
            return;
        }

        if (value > 100) {
            if (major === "facility") value = 5;
            else value = 100;
        }

        setEditing((prev) => {
            const updated = structuredClone(prev);

            if (major === "savior" || major === "facility") {
                updated[major] = value;
            } else if (major === "arcana") {
                updated[major].level = value;
            } else {
                updated[major][sub].level = value;
            }

            return updated;
        });
    };

    const ensureLevel = (major, sub, textValue) => {
        let value = Number(textValue);
        if (Number.isNaN(value) || value <= 0) {
            value = 1;

            setEditing((prev) => {
                const updated = structuredClone(prev);

                if (major === "savior" || major === "facility") {
                    updated[major] = value;
                } else if (major === "arcana") {
                    updated[major].level = value;
                } else {
                    updated[major][sub].level = value;
                }

                return updated;
            });
        }
    };

    const changeLastType = (major, sub, clicked) => {
        setEditing((prev) => {
            const updated = structuredClone(prev);

            if (major === "arcana") {
                if (clicked === "def") {
                    updated[major].lastType = editing[major].lastType !== "def" ? "def" : "atk";
                } else if (clicked === "atk") {
                    updated[major].lastType = editing[major].lastType !== "atk" ? "atk" : null;
                }
            } else {
                if (clicked === "def") {
                    updated[major][sub].lastType = editing[major][sub].lastType !== "def" ? "def" : "atk";
                } else if (clicked === "atk") {
                    updated[major][sub].lastType = editing[major][sub].lastType !== "atk" ? "atk" : null;
                }
            }

            return updated;
        });
    };

    return (
        <div
            className={`modal items overflow ${editingTactics !== null ? "active" : ""}`}
            // onClick={(e) => {
            //     if (e.target.classList.contains("modal")) {
            //         setEditingTactics(null);
            //     }
            // }}
        >
            <div className="window">
                <button className="close-button" onClick={() => setEditingTactics(null)}>
                    <i className="fi fi-sr-x" />
                </button>
                {editing !== null && (
                    <div className={styles["tactics-selector-container"]}>
                        <div className={styles["title"]}>{getUIText(lang, "simulator.title.tactics")}</div>
                        <div className={styles["row"]}>
                            <span>{getUIText(lang, "simulator.savior.tactics.facility.title")}</span>
                            <input
                                type="text"
                                value={editing.facility}
                                onChange={(e) => changeLevel("facility", null, e.target.value)}
                                onBlur={(e) => ensureLevel("facility", null, e.target.value)}
                            />
                        </div>
                        <div className={styles["row"]}>
                            <span>{getUIText(lang, "simulator.savior.tactics.savior.title")}</span>
                            <input
                                type="text"
                                value={editing.savior}
                                onChange={(e) => changeLevel("savior", null, e.target.value)}
                                onBlur={(e) => ensureLevel("savior", null, e.target.value)}
                            />
                        </div>
                        <div className={styles["row"]}>
                            <span>{getUIText(lang, "simulator.savior.tactics.arcana.title")}</span>
                            <input
                                type="text"
                                value={editing.arcana.level}
                                onChange={(e) => changeLevel("arcana", null, e.target.value)}
                                onBlur={(e) => ensureLevel("arcana", null, e.target.value)}
                            />
                            <button
                                type="button"
                                className={`${styles["check-button"]} ${styles["atk"]} ${editing.arcana.lastType !== null ? `${styles["active"]}` : ""}`}
                                onClick={() => changeLastType("arcana", null, "atk")}
                            >
                                {getUIText(lang, "simulator.total.atk")}
                            </button>
                            <button
                                type="button"
                                className={`${styles["check-button"]} ${styles["def"]} ${editing.arcana.lastType === "def" ? `${styles["active"]}` : ""}`}
                                onClick={() => changeLastType("arcana", null, "def")}
                            >
                                {getUIText(lang, "simulator.total.hp")}
                            </button>
                        </div>
                        <hr />
                        {Object.keys(editing.attr).map((attr) => {
                            return (
                                <div className={styles["row"]}>
                                    <span>{SAVIOR_ATTRIBUTE[`NUAT_${attr.toUpperCase()}`][lang]}</span>
                                    <input
                                        type="text"
                                        value={editing.attr[attr].level}
                                        onChange={(e) => changeLevel("attr", attr, e.target.value)}
                                        onBlur={(e) => ensureLevel("attr", attr, e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className={`${styles["check-button"]} ${styles["atk"]} ${editing.attr[attr].lastType !== null ? `${styles["active"]}` : ""}`}
                                        onClick={() => changeLastType("attr", attr, "atk")}
                                    >
                                        {getUIText(lang, "simulator.total.atk")}
                                    </button>
                                    <button
                                        type="button"
                                        className={`${styles["check-button"]} ${styles["def"]} ${editing.attr[attr].lastType === "def" ? `${styles["active"]}` : ""}`}
                                        onClick={() => changeLastType("attr", attr, "def")}
                                    >
                                        {getUIText(lang, "simulator.total.hp")}
                                    </button>
                                </div>
                            );
                        })}
                        <hr />
                        {Object.keys(editing.class).map((className) => {
                            return (
                                <div className={styles["row"]}>
                                    <span>{SAVIOR_CLASS[`NURT_${className.toUpperCase()}`][lang]}</span>
                                    <input
                                        type="text"
                                        value={editing.class[className].level}
                                        onChange={(e) => changeLevel("class", className, e.target.value)}
                                        onBlur={(e) => ensureLevel("class", className, e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className={`${styles["check-button"]} ${styles["atk"]} ${editing.class[className].lastType !== null ? `${styles["active"]}` : ""}`}
                                        onClick={() => changeLastType("class", className, "atk")}
                                    >
                                        {getUIText(lang, "simulator.total.atk")}
                                    </button>
                                    <button
                                        type="button"
                                        className={`${styles["check-button"]} ${styles["def"]} ${editing.class[className].lastType === "def" ? `${styles["active"]}` : ""}`}
                                        onClick={() => changeLastType("class", className, "def")}
                                    >
                                        {getUIText(lang, "simulator.total.hp")}
                                    </button>
                                </div>
                            );
                        })}

                        <div className={styles["buttons"]}>
                            <button type="button" className={styles["submit-button"]} onClick={() => submitEquip(editing)}>
                                {getUIText(lang, "simulator.modal.tactics.confirm")}
                            </button>
                            <button type="button" className={styles["cancel-button"]} onClick={() => setEditingTactics(null)}>
                                {getUIText(lang, "simulator.modal.tactics.cancel")}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
